"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactLoadScript = _interopRequireDefault(require("react-load-script"));

var _ThdHeaderFooter = require("./ThdHeaderFooter.styles");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ThdHeaderFooter = function ThdHeaderFooter() {
  var _useState = (0, _react.useState)(true),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isBusy = _useState2[0],
      setIsBusy = _useState2[1];

  var channel = 'web';
  /** IMPORTANT: for some reason the third party header stops being responsive at 960
  so we better serve mobile header if less than that for better UX
  */

  if (channel === 'web' && window.innerWidth < 960) {
    channel = 'mobile';
  }

  var GlobalStyles = (0, _ThdHeaderFooter.globalHeaderStyles)(isBusy);
  (0, _react.useEffect)(function () {
    var observer = new MutationObserver(function () {
      var header = document.querySelector('.Header3');
      var messageBar = document.querySelector('.MessageBar');

      if (header && messageBar) {
        setIsBusy(false);
      }
    });
    observer.observe(document, {
      attributes: true,
      childList: true,
      characterData: false,
      subtree: true
    });
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_ThdHeaderFooter.StyledHeaderFooter, {
    busy: isBusy
  }, /*#__PURE__*/_react["default"].createElement(GlobalStyles, null), /*#__PURE__*/_react["default"].createElement(_reactLoadScript["default"], {
    url: "https://secure2.homedepot.com/hf/thirdparty/js/include.third_party.js",
    attributes: {
      'hfapp-callback': 'blinds',
      'hfapp-callertype': 'ThirdPartyDemoApp',
      'hfapp-environment': 'https://secure2.homedepot.com',
      bootstrap: 'false',
      channel: channel,
      id: 'THDHeaderFooter',
      src: 'https://secure2.homedepot.com/hf/thirdparty/js/include.third_party.js',
      type: 'text/javascript'
    }
  }));
};

ThdHeaderFooter.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ThdHeaderFooter"
};
var _default = ThdHeaderFooter;
exports["default"] = _default;